export enum Colors {
    white = '#ffffff',
    black = '#000000',
    grayOne = '#2c3439',
    grayTwo = '#4c5357',
    grayThree = '#99adb6',
    grayFour = '#b2c2c8',
    grayFive = '#ccd6db',
    graySix = '#e5ebed',
    graySeven = '#fbfbfc',
    grayEight = '#efefef',
    grayOther = '#f5f5f5',

    primaryDusk = '#27221D',
    dusk = '#2c3439',
    duskLight = '#4c5357',
    duskLighter = '#707579',
    duskLightest = '#969a9c',
    duskThirty = '#bfc2c3',
    duskTwenty = '#d5d6d7',
    duskTen = '#e9eaeb',
    duskOne = '#fcfdfd',
    duskTwo = '#A9A7A5',
    duskThree = '#f8f9f9',
    duskSeven = '#f0f1f1',

    vacasaYorange = '#ffad02',
    ownerYellow = '#ffd00a',
    guestYellow = '#ffe700',
    guestYellow_20 = '#fff1b6',
    guestYellow_40 = '#ffe36c',

    midnight = '#003349',
    midnight100 = '#003349',
    midnight90 = '#1a475b',
    midnight80 = '#335c6d',
    midnight70 = '#4d7080',
    midnight60 = '#668592',
    midnight50 = '#8099a4',
    midnight40 = '#99adb6',
    midnight30 = '#b2c2c8',
    midnight20 = '#ccd6db',
    midnight10 = '#e5ebed',
    midnight4 = '#f5f7f8',
    midnight2 = '#fbfbfc',
    midnight0 = '#fafbfb',

    gulf90 = '#1a8c9b',

    cabin = '#783d24',
    sunset = '#d62e4f',
    jewel = '#631c69',
    coast = '#004273',
    forest = '#0f633d',
    clay = '#d16333',
    coral = '#ff9470',
    wine = '#a3286d',
    surf = '#00899e',
    moss = '#6ba342',
    awareness = '#ddad49',
    awareness10 = '#fff8e7',
    awareness20 = '#fab60f',
    sand = '#ffd19e',
    lavander = '#d18ab2',
    caribbean = '#89d8c6',
    meadow = '#b2d872',
    lake = '#0078ab',
    lake10 = '#e5f1f6',

    alert = '#d62e4f',
    alert10 = '#faeaed',

    vacasaBlue = '#0E3348',
    textPrimary = '#454545',
    accent = '#1a8c9b',
}
